import tailwindConfig from 'tailwind.config';

/**
 * If it doesn't work make sure you have the classes in the safelist in tailwind.config.ts
 * @param borderWidth - Example: '2' = p-2 (tailwind classes)
 * @param borderRadius - Example: 'rounded-3xl'
 * @param color - Example: 'gradient-main'
 * @param utilities - Example: 'dark:'
 */
export function gradientDecodoBorderStyling({
  borderWidth = 'p-px', // Example: '2' = p-2 (tailwind classes)
  borderRadius = 'rounded-3xl', // Example: 'rounded-3xl'
  color = 'gradient-main', // Example: 'gradient-main'
  utilities = '', // Example: 'dark:'
}: {
  borderWidth: `p-${string}`;
  borderRadius: `rounded${string}`;
  color: keyof typeof tailwindConfig.theme.extend.borderColor;
  utilities?: string;
}) {
  // TODO add that you can can change sizing of border with padding/border and :before inset and padding
  return `${utilities}border-${color} ${utilities}border-gradient-base ${utilities}before:bg-${color} ${utilities}before:${borderRadius} ${utilities}before:!${borderWidth} ${utilities}border-none ${utilities}before:border-${color} ${utilities}overflow-visible
  `;
}
